import {
    bootstrap as sharedBootstrap,
    BootstrapOptions as SharedBootstrapOptions,
} from 'owa-shared-bootstrap';
// Import setHtmlLangOrchestrator so that it gets run.
import './orchestrators/setHtmlLangOrchestrator';
import 'owa-fabric-theme'; // Need to initialize orchestrators that listen for theme and locale change
import { DesktopErrorComponentAsync } from 'owa-desktop-error-component';
import { getWindowTitle } from './initialization/getWindowTitle';
import { initializeOwaLocalization } from './initialization/initializeOwaLocalization';
import initializeTheme from './initialization/initializeTheme';

export interface BootstrapOptions
    extends Omit<
        SharedBootstrapOptions,
        'getWindowTitle' | 'initializeLocalization' | 'fullErrorComponent'
    > {
    getModuleName: () => string;
}

function bootstrap({ getModuleName, ...options }: BootstrapOptions) {
    return sharedBootstrap({
        ...options,
        getWindowTitle: () => getWindowTitle(getModuleName),
        initializeLocalization: initializeOwaLocalization,
        fullErrorComponent: DesktopErrorComponentAsync,
        prerenderPromises: [
            ...(options.prerenderPromises || []),
            options.initialConfig.sessionDataPromise.then(sessionData =>
                initializeTheme(sessionData.owaUserConfig)
            ),
        ],
    });
}

export { bootstrap };
